import React from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '../services/api';
import WorkflowChart from '../components/WorkflowChart';
import AgentStatus from '../components/AgentStatus';
import RecentWorkflows from '../components/RecentWorkflows';

const Dashboard: React.FC = () => {
  const { data: workflowData } = useQuery({
    queryKey: ['workflow-history'],
    queryFn: () => api.getWorkflowHistory({ limit: 100 }), // Get last 100 workflows
    refetchInterval: 30000,
  });

  // Extract workflows array from paginated response
  const workflows = workflowData?.workflows || [];

  const { data: agentStatus } = useQuery({
    queryKey: ['agent-status'],
    queryFn: api.getAgentStatus,
    refetchInterval: 10000,
  });

  return (
    <div className="min-h-screen p-6 space-y-6">
      <div className="dashboard-card">
        <h2 className="text-2xl font-bold mb-6 text-white">
          System Overview
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
          <div className="stat-card">
            <div className="text-xs font-semibold uppercase tracking-wider text-zinc-400 mb-2">
              Active Workflows
            </div>
            <div className="text-3xl font-bold text-white">
              {workflows?.filter((w: any) => w.status === 'PROCESSING').length || 0}
            </div>
          </div>
          <div className="stat-card stat-card-green">
            <div className="text-xs font-semibold uppercase tracking-wider text-green-400 mb-2">
              Completed Today
            </div>
            <div className="text-3xl font-bold text-white">
              {workflows?.filter((w: any) => {
                if (w.status !== 'COMPLETED') return false;
                const today = new Date().toDateString();
                const completedDate = new Date(w.completed_at || w.updated_at).toDateString();
                return today === completedDate;
              }).length || 0}
            </div>
          </div>
          <div className="stat-card stat-card-orange">
            <div className="text-xs font-semibold uppercase tracking-wider text-orange-500 mb-2">
              IMAP Agents
            </div>
            <div className="text-3xl font-bold text-white">
              {agentStatus?.imap?.online || 0}
            </div>
          </div>
          <div className="stat-card">
            <div className="text-xs font-semibold uppercase tracking-wider text-zinc-400 mb-2">
              Domain Agents
            </div>
            <div className="text-3xl font-bold text-white">
              {agentStatus?.domain?.online || 0}
            </div>
          </div>
          <div className="stat-card">
            <div className="text-xs font-semibold uppercase tracking-wider text-purple-400 mb-2">
              Warmup Agents
            </div>
            <div className="text-3xl font-bold text-white">
              {agentStatus?.warmup?.online || 0}
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="dashboard-card">
          <WorkflowChart />
        </div>
        <div className="dashboard-card">
          <AgentStatus agents={agentStatus} />
        </div>
      </div>

      <RecentWorkflows workflows={workflows || []} />
    </div>
  );
};

export default Dashboard;